import { Box, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import AnimatedBox from './AnimatedBox';

// Shared header for every inner page, so the four pages stay in step instead of
// each carrying its own copy of the same gradient block.
const Wrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  padding: theme.spacing(18, 0, 12),
  background: `
    radial-gradient(90% 120% at 78% 0%, rgba(0, 212, 255, 0.22) 0%, transparent 58%),
    radial-gradient(70% 100% at 8% 100%, rgba(91, 141, 239, 0.20) 0%, transparent 60%),
    linear-gradient(160deg, #0A1628 0%, #12233D 55%, #0B1A2E 100%)
  `,

  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(14, 0, 9),
  },

  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(12, 0, 7),
  },

  // Brand hairline closing the dark block against the page below.
  '&::after': {
    content: '""',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: '3px',
    background: theme.palette.accent.gradient,
  },
}));

const Glow = styled(Box)({
  position: 'absolute',
  top: '-30%',
  right: '-10%',
  width: '620px',
  height: '620px',
  borderRadius: '50%',
  background: 'radial-gradient(circle, rgba(0, 212, 255, 0.16) 0%, transparent 68%)',
  pointerEvents: 'none',
});

export default function PageHero({ title, subtitle, children }) {
  return (
    <Wrapper>
      <Glow />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <AnimatedBox animation="fadeInUp">
          <Typography
            variant="h1"
            sx={{
              color: 'text.light',
              mb: subtitle ? 2.5 : 0,
              maxWidth: '840px',
              fontSize: { xs: '2.25rem', sm: '3rem', md: '3.75rem' },
              letterSpacing: '-0.025em',
              lineHeight: 1.08,
            }}
          >
            {title}
          </Typography>

          {subtitle && (
            <Typography
              variant="body1"
              sx={{
                color: 'rgba(255, 255, 255, 0.68)',
                maxWidth: '620px',
                fontSize: { xs: '1rem', md: '1.1875rem' },
                lineHeight: 1.65,
              }}
            >
              {subtitle}
            </Typography>
          )}

          {children}
        </AnimatedBox>
      </Container>
    </Wrapper>
  );
}
